import { TagsList } from "./TagsList";
import { ClientTag } from "@avenueops/shared-types";
import { DynamicTag } from "@prisma/client";

interface Props {
  tags: ClientTag[];
  parentObject: { type: "WORKFLOW" | "PROCESS" | "WORKFLOW_BULK_ACTION"; ids: string[] };
  dynamicTags?: DynamicTag[];
  workflowId?: string;
  readOnly?: boolean;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export default function TagsSection({ tags, parentObject, dynamicTags, workflowId, readOnly, size = "MEDIUM" }: Props) {
  return (
    <>
      {parentObject.type === "WORKFLOW" ? <h3 className="text-black text-xl font-semibold mb-2">Tags</h3> : null}
      <TagsList tags={tags} parentObject={parentObject} dynamicTags={dynamicTags} workflowId={workflowId} readOnly={readOnly} size={size} />
    </>
  );
}
